import { metadataDefinitions, type MetadataValues } from "./metadata-schema";

export function applySlotBindingDefaults(element: MetadataValues, values: MetadataValues): MetadataValues {
  const field = String(element.bind).split(".")[1];
  if (field === "platform_icon") return { ...element, type: "icon" };

  const updated = { ...element };
  delete updated.type;
  const needsStyle = element.type === "icon" || !element.style;
  if (!needsStyle) return updated;

  const styles = metadataDefinitions(values, "styles");
  const preferredStyle = field === "member_only" ? "member_only" : `stream_${field}`;
  const hasPreferredStyle = styles[preferredStyle] !== undefined;
  updated.style = hasPreferredStyle ? preferredStyle : "stream_subtitle";
  return updated;
}
